<!--
 * @Description: 查看自己录入数据
 * @Autor: lwq
 * @Date: 2020-08-15 14:12:41
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-15 17:38:18
 * @FilePath: \mrc-base-server-view\src\views\data-access-strategy\modules\ViewDataOfSubordinates\index.vue
-->
<template>
  <v-card>
    <v-card-text class="px-7">
      <showDataAccessHeader v-model="obj.num"
                            :readonly='true'
                            :label="$t('label_View_your_own_data')"
                            :showAdd='false'></showDataAccessHeader>
    </v-card-text>
    <mrc_ess_submitBtn @success='success'
                       v-if="!$store.state.uuid"
                       :cancelText="$store.state.uuid?$t('label_cancel'):$t('label_The_previous_step')"
                       @cancel='cancel'>
    </mrc_ess_submitBtn>
  </v-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import showDataAccessHeader from '../showDataAccessHeader'
export default {
  components: { showDataAccessHeader },
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      obj: {
        num: '1'
      }
    };
  },
  validations: {},
  computed: {},
  created () { },
  watch: {},
  mounted () {

  },

  methods: {
    add () {
      this.open = true
    },
    success () {
      if (this.$store.state.uuid) {//修改
        this.$emit('success')
      }
      else {//新增
        this.$emit('success')
      }
    },
    async cancel () {
      if (this.$store.state.uuid) {
        this.$emit('updateSuccess')
      }
      else {
        this.$emit('cancel')
      }
    }
  },
};
</script>

<style scoped>
</style>
